import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import axios from "axios";
import {
  formatMoneda,
  formatoMonto,
  seleccionarCampo,
  validaMonto,
} from "../../util/varios";

export const ModalTimbreTramites = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [fijo, setFijo] = useState("true");
  const [calculo, setCalculo] = useState("1");
  const [entes, setEntes] = useState([]);
  const [dependencias, setDependencias] = useState([]);
  const [values, setValues] = useState({
    idtramite: "0",
    iddependencia: "",
    idente: "",
    nombre: "",
    monto: 0.0,
    fijo: "true",
    factorcalculo: "1",
    titulo: "",
    informacion: "",
  });
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [ute, setUte] = useState(0.0);

  const txtute = useRef();
  const txtMontoBs = useRef();
  const txtValorute = useRef();
  const txtNombre = useRef();
  const txtTitulo = useRef();
  const txtInformacion = useRef();
  const cmbEnte = useRef();
  const cmbDependencia = useRef();
  const cmbFijo = useRef();
  const cmbFactor = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();

  const onChange = (event) => {
    if (event.target.name === "idente") {
      if (event.target.value !== "") {
        seleccionarDependencias(false, event.target.value);
      } else {
        setDependencias([]);
        cmbDependencia.current.value = "";
      }
    } else if (event.target.name === "fijo") {
      event.target.value = event.target.value;
      setFijo(event.target.value);
    } else if (event.target.name === "factorcalculo") {
      event.target.value = event.target.value;
      setCalculo(event.target.value);
    } else {
      event.target.value = event.target.value.toUpperCase();
    }

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onChangeT = (event) => {
    if (event.which === 13) {
      if (event.target.name === "idente") {
        cmbDependencia.current.focus();
      } else if (event.target.name === "iddependencia") {
        txtNombre.current.focus();
      } else if (event.target.name === "nombre") {
        cmbFijo.current.focus();
      } else if (event.target.name === "fijo") {
        cmbFactor.current.focus();
      } else if (event.target.name === "factorcalculo") {
        txtTitulo.current.focus();
      } else if (event.target.name === "titulo") {
        txtInformacion.current.focus();
      } else if (event.target.name === "informacion") {
        btnAcepta.current.focus();
      }
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      /*       if (event.target.name === "monto") {
        let mon1 = parseFloat(ute);
        let mon2 = parseFloat(
          event.target.value.replace(/\./g, "").replace(",", ".")
        );
        let tot = mon1 * mon2;
        txtMontoBs.current.value = formatMoneda(
          tot.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      } */
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  /*   const seleccionarValorUte = () => {
    let endpoint = `${op.conexion}/api/comun/valorpetro`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setUte(response.data.valor);
          txtute.current.value = formatMoneda(
            response.data.valor.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          if (props.operacion !== 1) {
            txtMontoBs.current.value = formatMoneda(
              parseFloat(response.data.valor) *
                parseFloat(props.tramite.monto)
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
              ",",
              ".",
              2
            );
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };
 */
  const seleccionarEntes = () => {
    let campos = "*";
    let nomtab = "tipoente";
    let orden = "idtipoente desc";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setEntes(response.data);
          } else {
            setEntes([]);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarDependencias = (desde, idente) => {
    let campos = "*";
    let nomtab = "dependencias";
    let nomid = "tipoente";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${idente}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setDependencias(response.data);
            if (desde && props.operacion !== 1) {
              cmbDependencia.current.value = props.tramite.iddependencia;
            } else {
              cmbDependencia.current.value = "";
            }
          } else {
            setDependencias([]);
            cmbDependencia.current.value = "";
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (cmbEnte.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Ente.",
        icono: "informacion",
      });
      sigue = false;
      cmbEnte.current.focus();
    } else if (cmbDependencia.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir la Dependencia.",
        icono: "informacion",
      });
      sigue = false;
      cmbDependencia.current.focus();
    } else if (txtNombre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Nombre.",
        icono: "informacion",
      });
      sigue = false;
      txtNombre.current.focus();
    } else if (txtValorute.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el monto de la ute.",
        icono: "informacion",
      });
      sigue = false;
      txtValorute.current.focus();
    } else if (txtValorute.current.value.trim() === "0,00") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "el monto de la ute no puede ser 0,00",
        icono: "informacion",
      });
      sigue = false;
      txtValorute.current.focus();
    } else if (txtTitulo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "el titulo no puede estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtTitulo.current.focus();
    } else if (txtInformacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "el campo informacion no puede estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtInformacion.current.focus();
    } else if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/solicitudtimbre/actualizarTramites/${props.operacion}`;
    let body;
    setActivate(true);

    var timbre = [];
    timbre.push({
      idtramite: values.idtramite,
      iddependencia: cmbDependencia.current.value,
      nombre: txtNombre.current.value.trim(),
      fijo: cmbFijo.current.value === "true" ? true : false,
      factorcalculo: parseInt(cmbFactor.current.value),
      titulo: txtTitulo.current.value,
      informacion: txtInformacion.current.value,
      monto: txtValorute.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", "."),
    });

    body = {
      tramites: timbre,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setActivate(false);
    setDeshabilitado(false);
    cmbEnte.current.value = "";
    cmbDependencia.current.value = "";
    txtNombre.current.value = "";
    //txtMontoBs.current.value = "0,00";
    txtValorute.current.value = "0,00";
    txtTitulo.current.value = "";
    txtInformacion.current.value = "";
    cmbFijo.current.value = "true";
    cmbFactor.current.value = "1";
    setCalculo("1");
    setFijo("true");
    setValues({
      idtramite: "0",
      idente: "",
      iddependencia: "",
      nombre: "",
      monto: 0.0,
      fijo: "true",
      factorcalculo: "1",
      titulo: "",
      informacion: "",
    });
  };

  const handleCloseSi = () => {
    Actualizar();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    props.onHide(1);
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = () => {
    blanquear();
    props.onHide(0);
  };

  useEffect(() => {
    if (props.operacion !== 1) {
      if (entes.length > 0) {
        cmbEnte.current.value = props.tramite ? props.tramite.tipoente : "";
      }
    } else {
      cmbEnte.current.value = "";
    }
  }, [entes]);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        /* seleccionarValorUte(); */
        seleccionarEntes();

        if (props.operacion >= 3) {
          setDeshabilitado(true);
        }

        if (props.operacion !== 1) {
          setValues(props.tramite);
          setCalculo(props.tramite.factorcalculo.toString());
          setFijo(props.tramite.fijo.toString());
          txtValorute.current.value = formatMoneda(
            props.tramite.monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          seleccionarDependencias(true, props.tramite.tipoente);
        }
      }}
    >
      <Modal.Header className="azulGradiant2">
        <Modal.Title style={{ color: "#fff" }}>Gestionar Tramites.</Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body
        className="amanecergris"
        style={{ backgroundColor: "#FFF", color: "" }}
      >
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div className="col-md-12" style={{ height: "65vh", overflow: "auto" }}>
          <div
            className="row col-md-12"
            style={{ fontFamily: "Times New Roman, Times, serif" }}
          >
            <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px" }}
              >
                Datos del Tramite
              </legend>
              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  ENTE:
                </label>
                <select
                  name="idente"
                  disabled={deshabilitado}
                  defaultValue={props.tramite && props.tramite.idente}
                  className="form-control"
                  ref={cmbEnte}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                >
                  <option value="">- Seleccione un Ente -</option>
                  {entes &&
                    entes.map((item, i) => (
                      <option key={i} value={item.idtipoente}>
                        {item.tipo}
                      </option>
                    ))}
                </select>
              </div>
              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  DEPENDENCIA:
                </label>
                <select
                  name="iddependencia"
                  disabled={deshabilitado}
                  defaultValue={props.tramite && props.tramite.iddependencia}
                  className="form-control"
                  ref={cmbDependencia}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                >
                  <option value="">- Seleccione una Dependencia -</option>
                  {dependencias &&
                    dependencias.map((item, i) => (
                      <option key={i} value={item.iddependencia}>
                        {item.nombre}
                      </option>
                    ))}
                </select>
              </div>
              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  DESCRIPCION:
                </label>
                <textarea
                  disabled={deshabilitado}
                  style={{ minHeight: 50 }}
                  name="nombre"
                  autoComplete="off"
                  ref={txtNombre}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={values.nombre}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="Descripcion"
                />
              </div>
              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  TITULO:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  name="titulo"
                  autoComplete="off"
                  ref={txtTitulo}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={values.titulo}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="titulo"
                />
              </div>
              <div className="input-group input-group-sm col-sm-12 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  INFORMACION:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  name="informacion"
                  autoComplete="off"
                  ref={txtInformacion}
                  onChange={onChange}
                  onKeyUp={onChangeT}
                  value={values.informacion}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="informacion"
                />
              </div>
              <div className="row col-md-12">
                <div className="input-group input-group-sm col-sm-6 mb-3">
                  <label
                    className="input-group-text"
                    style={{ backgroundColor: "#55acee", fontSize: 12 }}
                    id="inputGroup-sizing-sm"
                  >
                    CALCULO:
                  </label>
                  <select
                    style={{ fontWeight: "bold", backgroundColor: "orange" }}
                    name="fijo"
                    disabled={deshabilitado}
                    defaultValue={
                      props.tramite && props.tramite.fijo.toString()
                    }
                    className="form-control"
                    ref={cmbFijo}
                    onChange={onChange}
                    onKeyUp={onChangeT}
                  >
                    <option value="true">FIJO</option>
                    <option value="false">VARIABLE</option>
                  </select>
                </div>

                <div className="input-group input-group-sm col-sm-6 mb-3">
                  <label
                    className="input-group-text"
                    style={{ backgroundColor: "#55acee", fontSize: 12 }}
                    id="inputGroup-sizing-sm"
                  >
                    POR:
                  </label>
                  <select
                    name="factorcalculo"
                    disabled={deshabilitado}
                    style={{ fontWeight: "bold", backgroundColor: "orange" }}
                    defaultValue={
                      props.tramite && props.tramite.factorcalculo.toString()
                    }
                    className="form-control"
                    ref={cmbFactor}
                    onChange={onChange}
                    onKeyUp={onChangeT}
                  >
                    <option value="0">CANTIDAD</option>
                    <option value="1">PORCENTAJE</option>
                  </select>
                </div>
              </div>
              <div className="input-group input-group-sm col-sm-3 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee" }}
                  id="inputGroup-sizing-sm"
                >
                  {calculo === "0" ? "CANTIDAD U.T.E" : "PORCENTAJE %: "}
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  name="monto"
                  autoComplete="off"
                  ref={txtValorute}
                  onFocus={seleccionarCampo}
                  onBlur={handleInputMontoChange}
                  onKeyUp={handleInputMontoChange}
                  defaultValue={"0,00"}
                  className="form-control text-end"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="0,00"
                  title="valor del tramite"
                />
              </div>
              {/*               x
              <div className="input-group input-group-sm col-sm-3 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  VALOR U.T.E
                </label>
                <input
                  type="text"
                  disabled
                  name="ute"
                  autoComplete="off"
                  ref={txtute}
                  onFocus={seleccionarCampo}
                  onBlur={handleInputMontoChange}
                  onKeyUp={handleInputMontoChange}
                  defaultValue={"0,00"}
                  className="form-control text-end"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="0,00"
                  title="valor del tramite"
                />
              </div>
              =
              <div className="input-group input-group-sm col-sm-3 mb-3">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "#55acee", fontSize: 12 }}
                  id="inputGroup-sizing-sm"
                >
                  MONTO BS
                </label>
                <input
                  type="text"
                  disabled
                  name="bs"
                  autoComplete="off"
                  ref={txtMontoBs}
                  onFocus={seleccionarCampo}
                  onBlur={handleInputMontoChange}
                  onKeyUp={handleInputMontoChange}
                  defaultValue={"0,00"}
                  className="form-control text-end"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder="0,00"
                  title="valor del tramite"
                />
              </div> */}
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          disabled={props.operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/timbre_fiscal_electronico/modal_timbre_tramites.js